import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import {
  parseOptionsWithUpdatedDate,
  parseProductsNameAndIdOptionsWithUpdateDate
} from '../../utils/parseResponseToOptions.jsx';
import UpdateProduct from './component';

class UpdateProductContainer extends Component {
  constructor() {
    super();
    this.state = {
      disabled: true,
      products: [],
      loading: false,
      formData: null,
      manufacturerId: null,
      productName: '',
      isActive: 0,
      updateLoading: false
    };
  }

  componentDidMount() {
    this.setState({
      loading: true
    });

    this.props.getDataFromAPI(
      '/products/all',
      'GET',
      undefined,
      response => {
        this.setState({
          products: response.list,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch products list');
        this.setState({
          loading: false
        });
      }
    );
  }

  onChangeOfProductId = (event, data) => {
    const productId = data.value;

    // fetch product details
    this.setState({
      loading: true,
      disabled: true
    });

    this.props.getDataFromAPI(
      `/products?productId=${productId}`,
      'GET',
      undefined,
      response => {
        const productDetails = response.list[0];
        this.setState({
          productId: productDetails.id,
          manufacturerId: productDetails.manufacturer_id,
          productName: productDetails.name,
          isActive: productDetails.is_active
        });

        // get forms
        this.props.getDataFromAPI(
          '/form/mv/dropdowns',
          'GET',
          undefined,
          response => {
            this.setState({
              formData: response,
              loading: false,
              disabled: false
            });
          },
          err => {
            console.log(err);
            toastr.error('Failed', 'Unable to fetch dropdown options');
            this.setState({
              loading: false,
              disabled: false
            });
          }
        );
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch product details');
        this.setState({
          loading: false
        });
      }
    );
  };

  // fields handler
  onChangeOfManufacturerId = (event, data) => {
    this.setState({
      manufacturerId: data.value
    });
  };

  onChangeOfProductName = event => {
    this.setState({
      productName: event.target.value
    });
  };

  onChangeOfStatus = (event, data) => {
    console.log(data.value);
    this.setState({
      isActive: parseInt(data.value, 10) ? 1 : 0
    });
  };

  handleSubmit = () => {
    this.setState({
      loading: true,
      disabled: true,
      updateLoading: true
    });

    const { productId, manufacturerId, productName, isActive } = this.state;

    const payload = {
      productId,
      mfId: manufacturerId,
      productName,
      isActive
    };

    this.props.getDataFromAPI(
      '/products/update',
      'PATCH',
      payload,
      response => {
        toastr.success('Successful', 'Updated Product');
        this.setState({
          loading: false,
          disabled: false,
          updateLoading: false
        });
        return this.props.history.push('/products/actions');
      },
      err => {
        this.setState({
          loading: false,
          disabled: false,
          updateLoading: false
        });
        toastr.error('Error', err);
      }
    );
  };

  render() {
    // console.log('---------------------------------------------');
    // console.log('state', this.state);

    const formData = this.state.formData;

    return (
      <UpdateProduct
        disabled={this.state.disabled}
        loading={this.state.loading}
        productCodesDD={parseProductsNameAndIdOptionsWithUpdateDate(this.state.products)}
        onChangeOfProductId={this.onChangeOfProductId}
        manufacturersDD={parseOptionsWithUpdatedDate((formData && formData.manufacturers) || [])}
        selectedManufacturer={this.state.manufacturerId}
        productName={this.state.productName}
        isActive={this.state.isActive}
        onChangeOfProductName={this.onChangeOfProductName}
        onChangeOfVariantId={this.onChangeOfVariantId}
        onChangeOfStatus={this.onChangeOfStatus}
        onChangeOfManufacturerId={this.onChangeOfManufacturerId}
        submitLoading={this.state.updateLoading}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(UpdateProductContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/UpdateProducts/container.jsx